import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import { QuicksightDashboard } from "api/memberPortal/reports/quicksight/quicksight.types";

import { dashboardIconConfig } from "./DashboardIconConfig";

interface DashboardCardProps {
  dashboard: QuicksightDashboard;
}

const DashboardCard = ({
  dashboard: { id, name, description, variant, slug },
}: DashboardCardProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (variant === "legacy") {
      navigate(slug);
    } else {
      navigate(`${id}/${slug}`);
    }
  };

  const { color, Icon } = dashboardIconConfig[variant];
  return (
    <Card
      sx={{
        width: 200,
      }}
      elevation={2}
    >
      <CardActionArea onClick={handleClick} sx={{ height: "100%" }}>
        <CardMedia
          sx={{
            height: 140,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#f9f9f9",
            borderBottom: `${color} 2px solid`,
          }}
        >
          {
            <Icon
              sx={{
                fontSize: "90px",
                color: color,
              }}
            />
          }
        </CardMedia>

        <CardContent sx={{ height: "100%" }}>
          {/* WARN: Custom styling from pre standardization! */}
          {/* TODO: Standardize when you come across this!  */}
          <Typography gutterBottom variant="h6" component="div" fontSize={16}>
            {name}
          </Typography>
          {/* WARN: Custom styling from pre standardization! */}
          {/* TODO: Standardize when you come across this!  */}
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            {description}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};
export default DashboardCard;
